import React, { Component } from 'react'
import Input from './../input'
import Radio from './../radio'
import _ from 'underscore'
import BVTextArea from './../textarea'

class FTPPassword extends Component{
	render () {
		const {sshkey, handstyle} = this.props
		return <div className="col-xs-12 col-md-12">
			<i className="mdi mdi-lock-outline"></i>
			<Input name="passwd" className="bv-ftp-password" type="password" placeholder="Enter FTP password here" title={ <span>FTP Password <span className="label label-default" style={ handstyle() } onClick={sshkey}>SSH Key</span></span> } />
		</div>
	}
}

class SFTPKey extends Component{
	render () {
		const {sshkey, handstyle} = this.props
		return <div className="col-xs-12 col-md-12">
			<i className="mdi mdi-key"></i>
			<BVTextArea name="key_data" className="bv-ftp-password" placeholder="Paste SSH Private key here" title={ <span>SSH Key <span className="label label-default" style={ handstyle() } onClick={sshkey}>FTP Password</span></span> } />
		</div>
	}
}

class GenericFormInputFields extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.onRadioClick = this.onRadioClick.bind(this)
		this.sshkey = this.sshkey.bind(this)
	}

	componentDidMount(){
		this.setRadioType()
	}

	setRadioType(){
		const { fields } = this.props
		let type = fields['type'] || "ftp"
		this.setState({radio: type})
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors, fields } = this.props
		let classname
		if (key == "address"){
			classname = "col-md-9 col-xs-9"
		} else if (key == "port"){
			classname = "col-md-3 col-xs-3"
		} else {
			classname = "col-md-12 col-xs-12"
		}
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}
	onRadioClick(value) {
		this.setState({ radio: value })
	}
	handstyle() {
		return { cursor: "pointer" }
	}
	sshkey() {
		this.setState({ sshKey: !this.state.sshKey })
	}
	passfield() {
		const { radio, sshKey} = this.state
		let type = (this.fetchValue('type') === "") ? radio : this.fetchValue('type')
		if (type == "sftp") {
			if (sshKey) {
				return <SFTPKey sshkey={this.sshkey} handstyle={this.handstyle} />
			} else {
				return <FTPPassword sshkey={this.sshkey} handstyle={this.handstyle} />
			}
		} else {
			return (
				<div className="col-xs-12 col-md-12">
					<i className="mdi mdi-lock-outline"></i>
					<Input name="passwd" type="password" placeholder="Enter FTP password here" title="FTP Password" />
				</div>
			)
		}
	}
	render(){
		return (
			<div>
				<p className="bv-form-title" style={{textAlign: "left"}}>Enter FTP Details of the new site that you want to migrate to</p>
				<div className="row">
					<div className={this.getClassName('newurl')}>
						<i className="mdi mdi-web"></i>
						<Input
							type="text"
							name="newurl"
							title="Destination Site URL"
							placeholder="Eg. www.google.com"
							classname=""
							value={this.fetchValue('newurl')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('type')}>
						<Radio
							name="type"
							title="FTP Type"
							items={['ftp', 'sftp', 'ftps']}
							value={this.fetchValue('type') || 'ftp'}
							widthClass="col-xs-4 col-md-4"
							iconClass="mdi mdi-clipboard-arrow-left"
							onClick={this.onRadioClick}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('address')}>
						<i className="mdi mdi-server"></i>
						<Input
							type="text"
							name="address"
							title="Destination Server IP/FTP Address"
							placeholder="Eg. 127.0.0.1"
							classname=""
							value={this.fetchValue('address')}
						/>
					</div>
					<div className={this.getClassName('port')}>
						<Input
							type="number"
							name="port"
							title="Port(optional)"
							placeholder=""
							classname=""
							value={this.fetchValue('port')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('username')}>
						<i className="mdi mdi-account"></i>
						<Input
							type="text"
							name="username"
							title="FTP Username"
							placeholder="Enter FTP username here"
							classname=""
							value={this.fetchValue('username')}
						/>
					</div>
				</div>
				<div className="row">
					{ this.passfield() }
				</div> 
				<div className="row">
					<div className={this.getClassName('path')}>
						<i className="mdi mdi-folder"></i>
						<Input
							type="text"
							name="path"
							title="Directory Path"
							placeholder="Eg. /var/www/html"
							classname=""
							value={this.fetchValue('path')}
						/>
					</div>
				</div>
				<div className="row hide-field">
					<Input
						type="hidden"
						name="migrate"
						value="generic"
						title=""
						placeholder=""
						classname=""
					/>
				</div>
			</div>
		)
	}
}

export default GenericFormInputFields
